import { render, staticRenderFns } from "./BucketFilter.vue?vue&type=template&id=82476bb2&scoped=true&"
import script from "./BucketFilter.vue?vue&type=script&lang=ts&"
export * from "./BucketFilter.vue?vue&type=script&lang=ts&"
import style0 from "./BucketFilter.vue?vue&type=style&index=0&id=82476bb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82476bb2",
  null
  
)

export default component.exports